<div class="rtp-container">
  <p class="text-muted">Add details for every item in the list. After saving you can see checklist details.</p>

  @for (item of rtpItems; track item.id; let i = $index) {
    <div class="item-row mb-4">
      <div class="row g-1 align-items-end">
        <div class="col-xxl-1 col-2">
          <div class="id-badge text-center">{{ item.id }}</div>
        </div>
        <div class="col-xxl-2 col-3">
          <input-field
            [inputFormControl]="$any(item).nameControl || createFormControl(item, 'name')"
            [placeholder]="'Name'" [label]="'Name'"
            (valueChange)="updateItemField(item, 'name', $event)">
          </input-field>
        </div>
        <div class="col-xxl-1 col-2 minw-field platform-field">
          <select-field
            [selectFormControl]="$any(item).platformControl || createFormControl(item, 'platform')"
            [options]="platformOptions" [label]="'Platform'"
            (valueChange)="updateItemField(item, 'platform', $event)">
          </select-field>
        </div>
        <div class="col-xxl-2 col-5">
          <input-field
            [inputFormControl]="$any(item).reportedByClientControl || createFormControl(item, 'reportedByClient')"
            [label]="'Reported by Client'"
            (valueChange)="updateItemField(item, 'reportedByClient', $event)">
          </input-field>
        </div>
        <div class="col-xxl-2 col-5">
          <input-field
            [inputFormControl]="$any(item).reportedInGameControl || createFormControl(item, 'reportedInGame')"
            [label]="'Reported in Game'"
            (valueChange)="updateItemField(item, 'reportedInGame', $event)">
          </input-field>
        </div>
        <div class="col-xxl-1 col-2 minw-field verified-field">
          <input-field
            [inputFormControl]="$any(item).verifiedByGlobalControl || createFormControl(item, 'verifiedByGlobal')"
            [label]="'Verified by Global'"
            [type]="'number'"
            (valueChange)="updateItemField(item, 'verifiedByGlobal', $event)">
          </input-field>
        </div>
        <div class="col-xxl-1 col-4 minw-field verification-field">
          <select-field
            [selectFormControl]="$any(item).verificationControl || createFormControl(item, 'verification')"
            [options]="verificationOptions" [label]="'Verification'"
            (valueChange)="updateItemField(item, 'verification', $event)">
          </select-field>
        </div>
        <div class="col-1 ms-auto d-flex justify-content-center maxw-field btn-field">
          <button type="button" class="btn btn-danger" (click)="removeItem(i)">
            <i class="bi bi-trash"></i>
          </button>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <textarea-field
            [textareaFormControl]="$any(item).commentControl || createFormControl(item, 'comment')"
            [placeholder]="'Insert comment'" [label]="'Comment'"
            [height]="80"
            (valueChange)="updateItemField(item, 'comment', $event)">
          </textarea-field>
        </div>
      </div>
    </div>
  }

  <div class="row mt-3">
    <div class="col-12 text-end">
      <button type="button" class="btn btn-success me-2" (click)="addNewItem()">
        <i class="bi bi-plus-circle"></i> Add Item
      </button>
      <button type="button" class="btn btn-primary" (click)="saveRtpData()">
        <i class="bi bi-save"></i> Save
      </button>
    </div>
  </div>
</div>
